import { createStyles, Grid, WithStyles, withStyles } from '@material-ui/core';
import { inject } from 'mobx-react';
import React from 'react';
import IDataTableManager from 'src/common/IDataTableManager';
import { IActionItem } from 'src/Definitions';
import { IStores } from 'src/Stores';
import ActionItems from './ActionItemTable/ActionItems';

const styles = createStyles({
    actionItemPageLink: {
        bottom: '20px',
        left: '0',
        marginLeft: '40px',
        position: 'absolute',
        textDecoration: 'underline',
        width: '150px',
    },
    actionItemPageLinkContainer: {
        color: '#a2a3a5',
        fontSize: '12px',
        position: 'relative',
    },
    rowHeader: { color: '#2429cb', marginLeft: '20px' },
    rowHeaderContainer: {
        display: 'flex',
    },
    tableHeader: {
        marginBottom: '-30px',
        marginLeft: '20px',
    },
});

interface IActionItemTableRowProps {
    dueIn30DataTableManager?: IDataTableManager<IActionItem>;
    completedDataTableManager?: IDataTableManager<IActionItem>;
    rerouteToPath?: (path: string) => void;
}

class ActionItemTableRow extends React.Component<
    IActionItemTableRowProps & WithStyles<typeof styles>
> {
    public componentDidMount() {
        this.props.dueIn30DataTableManager!.tableOptions.page = 1;
        this.props.completedDataTableManager!.tableOptions.page = 1;
    }

    private routeToActionItems = () => () => {
        this.props.rerouteToPath!('/actionitems');
    };

    public render() {
        const { dueIn30DataTableManager, completedDataTableManager } = this.props;
        return (
            <Grid container direction="column">
                <Grid item>
                    <div className={this.props.classes.rowHeaderContainer}>
                        <h3 className={this.props.classes.rowHeader}>Action Items</h3>
                        <a
                            className={this.props.classes.actionItemPageLinkContainer}
                            href="#"
                            onClick={this.routeToActionItems()}
                        >
                            <div className={this.props.classes.actionItemPageLink}>
                                View All Action Items
                            </div>
                        </a>
                    </div>
                </Grid>
                <Grid item>
                    <Grid container direction="row" justify="space-around">
                        <Grid item xs={6}>
                            <Grid container direction="column">
                                <h4 className={this.props.classes.tableHeader}>Due in 30 Days</h4>
                                <ActionItems dataTableManager={dueIn30DataTableManager} />
                            </Grid>
                        </Grid>
                        <Grid item xs={6}>
                            <Grid container direction="column">
                                <h4 className={this.props.classes.tableHeader}>Completed</h4>
                                <ActionItems dataTableManager={completedDataTableManager} />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        );
    }
}

const InjectedActionItemRow = inject<
    IStores,
    IActionItemTableRowProps,
    Partial<IActionItemTableRowProps>,
    any
>((stores: IStores) => ({
    rerouteToPath: stores.global.rerouteToPath,
}))(withStyles(styles)(ActionItemTableRow));

export default InjectedActionItemRow;



// WEBPACK FOOTER //
// ./src/dashboardRows/ActionItemRow/ActionItemTableRow.tsx